module.exports = __webpack_public_path__ + "static/media/maxxam-logo-black.1d3a98ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/maxxam-logo-black.svg
// module id = 1029
// module chunks = 20